export default __webpack_public_path__ + "crop-symbol.png";